import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {ConfigService} from '@docma-mm-core/config/config.service';
import {BasedataService} from '@docma-mm-core/shared/basedata.service';
import {catchError} from 'rxjs/operators';

@Injectable()
export class ProjectIntegrationApiService extends BasedataService {

  constructor(private http: HttpClient, configService: ConfigService) {
    super(configService);
  }

  getProjectIntegrationImage(projectId: number, integrationId: number) {
    const endpoint = super.getFullUrl(`/integrations/${integrationId}/image`);
    return this.http
    .get<string>(endpoint, { headers: this.getHeaders(), responseType: 'image/svg+xml' as 'json'})
    .pipe(catchError(e  => this.handleError(e)));
  }
}
